/**
 * Density pure helpers — Phase 1a
 *
 * No React. Safe to call from useTheme or tests.
 *
 * Storage key: 'pia-density'
 * Default: 'cozy'
 */

import type { Density } from '../types/theme.js';

const STORAGE_KEY = 'pia-density';

/**
 * Read the stored density preference from localStorage.
 *
 * Falls back to 'cozy' if:
 *   - localStorage is empty or the key is absent
 *   - The stored value is not 'cozy' or 'compact'
 *   - localStorage.getItem throws (Safari private mode / sandboxed iframe)
 */
export function readStoredDensity(): Density {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (raw === 'cozy' || raw === 'compact') {
			return raw;
		}
		return 'cozy';
	} catch {
		return 'cozy';
	}
}

/**
 * Write the density to document.documentElement.dataset.density.
 * Compact reduces padding/row heights; cozy is the default spacious layout.
 */
export function applyDensity(density: Density): void {
	document.documentElement.dataset.density = density;
}
